import ImportUploadPage from '@/pages/catalog/ImportUploadPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/catalog/import/add')({
  component: ImportUploadPage,
})
